import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Video {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  alt: string;
  duration: string;
  views: number;
  category: string;
}

interface VideoTutorialProps {
  videos: Video[];
  onVideoClick: (videoId: string) => void;
}

const VideoTutorial: React.FC<VideoTutorialProps> = ({ videos, onVideoClick }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {videos.map((video) => (
        <div
          key={video.id}
          className="bg-card rounded-lg shadow-md overflow-hidden border border-border transition-all duration-300 hover:shadow-lg hover:scale-[1.02] cursor-pointer"
          onClick={() => onVideoClick(video.id)}
        >
          <div className="relative h-48 overflow-hidden group">
            <AppImage
              src={video.thumbnail}
              alt={video.alt}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-grounded-charcoal/40 flex items-center justify-center transition-opacity duration-300 group-hover:bg-grounded-charcoal/60">
              <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                <Icon name="PlayIcon" size={32} className="text-primary-foreground ml-1" />
              </div>
            </div>
            <div className="absolute bottom-3 right-3 px-2 py-1 bg-grounded-charcoal/80 rounded text-xs font-body font-medium text-white">
              {video.duration}
            </div>
          </div>

          <div className="p-5">
            <div className="flex items-center space-x-2 mb-2">
              <span className="px-2 py-1 bg-muted text-muted-foreground rounded text-xs font-body">
                {video.category}
              </span>
            </div>

            <h3 className="text-lg font-headline font-bold text-foreground mb-2 line-clamp-2">
              {video.title}
            </h3>

            <p className="text-sm font-body text-muted-foreground mb-4 line-clamp-2">
              {video.description}
            </p>

            <div className="flex items-center space-x-1 text-muted-foreground">
              <Icon name="EyeIcon" size={16} />
              <span className="text-sm font-body">{video.views.toLocaleString()} views</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VideoTutorial;